module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@12.1.0/~/vue-loader/lib/template-compiler?{"id":"data-v-3d6d4c48"}!./~/.store/vue-loader@12.1.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 917
// module chunks = 76